import classNames from "classnames/bind";
import styles from "./DepartmentList.module.css";
import HeaderModal from "../HeaderModal/HeaderModal";
import Table from "../Table/Table";
import { useEffect, useRef, useState } from "react";

const cx = classNames.bind(styles)

const DepartmentList = ({ listDp }) => {
    const [showModal, setShowModal] = useState(false)
    const refModal = useRef(null)
    const columns = [
        {
            key: 'name',
            label: "Tên phòng ban"
        }
    ]
    useEffect(() => {
        const handleCloseOnClickOutSide = (e) => {
            if (e.target === refModal.current) {
                setShowModal(false)
            }
        };
        document.addEventListener("click", handleCloseOnClickOutSide);
        return () => {
            document.removeEventListener("click", handleCloseOnClickOutSide);
        };
        // eslint-disable-next-line
    }, []);
    return (
        <>
            <div className={cx('wrapp-text')}>
                {listDp?.map((dp, index) => {
                    return <span key={dp?.id} className={cx('department-name')} onClick={() => setShowModal(!showModal)}>{dp?.name}{index !== listDp?.length - 1 ? ", " : ''}</span>
                })}
            </div>
            {showModal && (
                <div className={cx('wrapper')} ref={refModal}>
                    <div className={cx('content')}>
                        <HeaderModal title={"Danh sách phòng ban"} onClose={() => setShowModal(!showModal)} />
                        <div className={cx('table')}>
                            <Table colum={columns} data={listDp || []} />
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default DepartmentList;